/**
 * Per-Site / School Pre-selected Provider Orgs API service
 *
 * Endpoint: /api/v2/school-preselected-provider-orgs/
 *
 * Note: OpenAPI schema (schema.d.ts) for /api/v2/school-preselected-provider-orgs/
 * currently lacks @extend_schema annotations on the DRF GenericViewSet actions
 * (school_id query param on GET, request body / 200 response shape on POST).
 * Follow-up ticket: annotate backend viewset, regenerate schema.d.ts, and remove type assertions.
 */

import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export interface SchoolPreselectedProviderOrgItem {
  id: number;
  school: number;
  provider_org: number;
  provider_org_name: string;
  configured_by: number | null;
  configured_at: string;
  updated_at: string;
}

export interface SchoolPreselectedProviderOrgsResponse {
  school_id: number;
  provider_org_ids: number[];
  results: SchoolPreselectedProviderOrgItem[];
}

export interface UpdateSchoolPreselectedProviderOrgsPayload {
  school_id: string | number;
  provider_org_ids: (string | number)[];
}

/**
 * Fetch pre-selected provider orgs for a given school (site).
 * GET /api/v2/school-preselected-provider-orgs/?school_id={schoolId}
 */
export async function getSchoolPreselectedProviderOrgs(
  schoolId: number | string,
): Promise<SchoolPreselectedProviderOrgsResponse> {
  const result = await client.GET(
    '/api/v2/school-preselected-provider-orgs/' as any,
    {
      params: { query: { school_id: schoolId } as never },
    },
  );
  return unwrap(result) as unknown as SchoolPreselectedProviderOrgsResponse;
}

/**
 * Create / update pre-selected provider orgs for a given school (site).
 * POST /api/v2/school-preselected-provider-orgs/
 */
export async function setSchoolPreselectedProviderOrgs(
  payload: UpdateSchoolPreselectedProviderOrgsPayload,
): Promise<SchoolPreselectedProviderOrgsResponse> {
  const body = {
    school_id: Number(payload.school_id),
    provider_org_ids: payload.provider_org_ids.map((id) => Number(id)),
  };

  const result = await client.POST(
    '/api/v2/school-preselected-provider-orgs/' as any,
    {
      body: body as never,
    },
  );
  return unwrap(result) as unknown as SchoolPreselectedProviderOrgsResponse;
}
